// extracted by mini-css-extract-plugin
export default {"link":"Link_link__Vzf6H"};